export default __webpack_public_path__ + "static/media/uncleDunkelsMobile.7ac5ba44.jpg";